// src/components/SplashScreen.tsx
import React from "react";

export default function SplashScreen() {
  return (
    <div className="h-screen w-screen bg-dark-background flex items-center justify-center ">
      <div className="text-center">
        <img src="/splash.svg" ></img>
      </div>
    </div>
  );
}
